<template>
  <div class="bg bg-foot">
    <div class="foot">
      <div v-for="(item,i) in data" :key="i">
        <span>{{item.name}}</span>
        <p v-for="(child, k) in item.children" :key="k" @click="tohelp(child.id)">{{child.name}}</p>
      </div>
      <div style="margin-top:-15px;">
        <img src="../assets/wxcode.png" style="width:110px" alt />
      </div>
    </div>
    <!-- 成都市高新区高朋大道11号1栋1楼2号 -->
    <div class="copyright"><a style="color:white;" href="https://beian.miit.gov.cn/">蜀ICP备19031159号-1</a>|2022库蜂成都科技有限公司 版权所有</div>
  </div>
</template>

<script>
import { introList } from '@/js/api'
export default {
  name: "footer-nav",
  data(){
    return{
      data: []
    }
  },
  created() {
    this.list()
  },
  methods:{
    list() {
      introList({systemCode:'kufeng'}).then(res => {
        if (res.success) {
          this.data = res.result
        }
      })
    },
    tohelp(id){
      this.$router.push('/help?id='+id)
    }
  }
};
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  min-width: 1200px;
  margin: auto;
}
.foot {
  display: flex;
  width: 75%;
  // padding: 40px 100px 0px 140px;
  padding: 40px 0;
  margin: 0 auto;
  margin: auto;
  justify-content: space-between;
  > div {
    width: 25%;
    > span {
      font-size: 16px;
      font-weight:bold;
    }
    > p {
      margin-top: 5px;
      cursor:pointer;
    }
    // width: 240px;
    // &:last-child {
    //   flex: 2;
    //   padding-right: 110px;
    //   text-align: right;
    // }
  }
  p {
    line-height: 1.8;
  }
  img{
    max-width: 70%;
  }
}
.able {
  cursor: pointer;
  text-decoration: underline;
}
.copyright {
  text-align: center;
  line-height: 40px;
  background-color: rgb(99, 198, 149);
  color: #fff;
}
</style>
